<template>
  <v-row class="ma-10 fill-height" justify="center">
    <v-col cols="12" md="8" lg="6">
      <v-card class="pa-6" outlined>
        <v-card-title class="text-h5 px-0">
          Page Temporarily Unavailable
        </v-card-title>
        <v-card-text class="px-0">
          <p class="mb-2">
            The requested page could not be loaded.
          </p>
          <p class="mb-1"><strong>Path:</strong> {{ $route.path }}</p>
          <p v-if="isBoldPreflightIssue" class="mb-1">
            <strong>Preflight Check:</strong> {{ boldPreflightMessage }}
          </p>
          <p v-if="isChunkIssue" class="mb-0">
            A cached browser bundle may be out of date. Refresh the page to load
            the latest files.
          </p>
        </v-card-text>
        <v-card-actions class="px-0 pt-4">
          <v-btn color="primary" @click="$router.push('/dashboard')">
            Go To Dashboard
          </v-btn>
          <v-btn text @click="$router.push('/admin/bold-listings')">
            Open Bold Listings
          </v-btn>
          <v-btn text @click="reload">Refresh</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'RouteUnavailable',
  computed: {
    reason() {
      return this.$route.query.reason || ''
    },
    isBoldPreflightIssue() {
      return this.reason.indexOf('bold-preflight-') === 0
    },
    boldPreflightMessage() {
      switch (this.reason) {
        case 'bold-preflight-auth':
          return 'Session is not valid. Please sign in again.'
        case 'bold-preflight-permission':
          return 'You do not have permission to view this page.'
        case 'bold-preflight-server':
          return 'Server returned an error while checking Bold Listings.'
        case 'bold-preflight-timeout':
          return 'Request timed out while checking Bold Listings.'
        case 'bold-preflight-network':
          return 'Network check failed while loading Bold Listings.'
        default:
          return 'Unable to validate Bold Listings availability.'
      }
    },
    isChunkIssue() {
      return this.reason === 'chunk'
    }
  },
  methods: {
    reload() {
      window.location.reload()
    }
  }
}
</script>

<style scoped></style>
